<template>
  <CDropdown inNav class="c-header-nav-items" placement="bottom-end" add-menu-classes="pt-0">
    <template #toggler>
      <CHeaderNavLink> {{ account.displayName }} </CHeaderNavLink>
    </template>
    <!-- <CDropdownHeader tag="div" class="text-center" color="light">
      <strong>Account</strong>
    </CDropdownHeader>
    <CDropdownItem>
      <CIcon name="cil-bell"/> Updates
      <CBadge color="info" class="mfs-auto">{{ itemsCount }}</CBadge>
    </CDropdownItem>
    <CDropdownItem>
      <CIcon name="cil-envelope-open" /> Messages
      <CBadge color="success" class="mfs-auto">{{ itemsCount }}</CBadge>
    </CDropdownItem>
    <CDropdownItem>
      <CIcon name="cil-task" /> Tasks
      <CBadge color="danger" class="mfs-auto">{{ itemsCount }}</CBadge>
    </CDropdownItem>
    <CDropdownItem>
      <CIcon name="cil-comment-square" /> Comments
      <CBadge color="warning" class="mfs-auto">{{ itemsCount }}</CBadge>
    </CDropdownItem>
    <CDropdownHeader
      tag="div"
      class="text-center"
      color="light"
    >
      <strong>Settings</strong>
    </CDropdownHeader>
    <CDropdownItem>
      <CIcon name="cil-user" /> Profile
    </CDropdownItem>
    <CDropdownItem>
      <CIcon name="cil-settings" /> Settings
    </CDropdownItem>
    <CDropdownItem>
      <CIcon name="cil-dollar" /> Payments
      <CBadge color="secondary" class="mfs-auto">{{ itemsCount }}</CBadge>
    </CDropdownItem>
    <CDropdownItem>
      <CIcon name="cil-file" /> Projects
      <CBadge color="primary" class="mfs-auto">{{ itemsCount }}</CBadge>
    </CDropdownItem>
    <CDropdownDivider/> -->
    <CDropdownItem @click="password()"> <CIcon name="cil-user" /> 修改密碼 </CDropdownItem>
    <CDropdownItem @click="logout()"> <CIcon name="cil-lock-locked" /> 登出 </CDropdownItem>
  </CDropdown>
</template>

<script>
export default {
  name: "TheHeaderDropdownAccnt",
  data() {
    return {
      account: {
        gid: null,
        username: "",
        displayName: "",
      },
    };
  },
  methods: {
    password() {
      this.$router.push({ name: "修改密碼" });
    },
    logout() {
      localStorage.removeItem("authorization");
      localStorage.removeItem("authorizationRole");
      this.$notify({ type: "success", text: "登出成功" });
      this.$router.push({ name: "登入" });
    },
    getAccount() {
      this.$http.get("/account").then((response) => {
        if (response.data.success) {
          this.account.gid = response.data.result.gid;
          this.account.username = response.data.result.username;
          this.account.displayName = response.data.result.displayName;
          localStorage.setItem("authorizationRole", response.data.result.role);
        } else {
          this.$notify({ type: "error", text: response.data.message });
        }
      });
    },
  },
  mounted() {
    this.getAccount();
  },
};
</script>

<style scoped>
.c-icon {
  margin-right: 0.3rem;
}
</style>